import {
    Flex,
    // Box,
    FormControl,
    FormLabel,
    Input,
    // Checkbox,
    Stack,
    Button,
    // Heading,
    // Text,
    useColorModeValue,
    Image,
    // Link,
  } from '@chakra-ui/react';
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAdminLoginMutation } from "../../slices/adminApiSlice";
import { setCredentials } from "../../slices/adminAuthSlice";
import { PasswordField } from '../../components/PasswordField';
import { ToastService } from '../../services/toast/toastService';

const AdminLogin = () => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  //const toast = useToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { success, error } = ToastService();
  const [login, { isLoading }] = useAdminLoginMutation();
  const { adminInfo } = useSelector( (state) => state.adminAuth );
  const bgColor = useColorModeValue('gray.50', 'gray.700');
  const textColor = useColorModeValue('custom.800', 'custom.900');
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);

  useEffect( () => {
    if(adminInfo) {
      navigate('/admin');
    }

     // Load reCAPTCHA v3 script
     const loadRecaptcha = () => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        setRecaptchaLoaded(true);
      };
      document.body.appendChild(script);
    };
  
    if (!window.grecaptcha) {
      loadRecaptcha();
    } else {
      setRecaptchaLoaded(true);
    }
  
    return () => {
      const script = document.querySelector(`script[src^="https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}"]`);
      if (script) document.body.removeChild(script);
    };
  }, [ navigate, adminInfo ] );

  const getRecaptchaToken = async (action) => {
    try {
      // Wait for grecaptcha to be loaded
      await new Promise((resolve) => {
        const checkRecaptcha = () => {
          if (window.grecaptcha && window.grecaptcha.execute) {
            resolve();
          } else {
            setTimeout(checkRecaptcha, 100);
          }
        };
        checkRecaptcha();
      });

      const token = await window.grecaptcha.execute(
        process.env.REACT_APP_RECAPTCHA_SITE_KEY, 
        { action }
      );
      return token;
    } catch (err) {
      console.error('reCAPTCHA error:', err);
      //throw new Error('Failed to verify reCAPTCHA');
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    try {
      if (!recaptchaLoaded) {
        error("Security verification is still loading. Please try again.");
        return;
      }
      
      // Get reCAPTCHA token
      const token = await getRecaptchaToken('admin_register');
      if (!token) {
        error("Security verification failed. Please try again.");
        return;
      }

      const response = await login( { email, password, recaptchaToken: token } ).unwrap();
      if (response.success) {
        // Set user credentials in Redux store
        dispatch(setCredentials({ ...response.user }));

        success('Admin Login Successfully.')
        navigate('/admin');
      } else {
        error('Invalid login response.');
      }

    }catch(err){
        error(err.data?.message || 'An unexpected error occurred.')
    }
  };

  return (
    <Flex
      minH={'100vh'}
      justify={'center'}      
      bg={bgColor}
      color={textColor}
      width="100%">
      <Stack
        // bg={bgColorDark}
        w={'full'}
        maxW={'lg'}
        p={8}
        >
        <Image 
          src="/logo512.png" 
          alt="iFun Baby Logo" 
          boxSize="150px" 
          mx="auto" 
          mb={4} 
        />
          <form onSubmit={submitHandler}>
          <Stack spacing={4}>
            <FormControl isRequired id="email">
              <FormLabel>Email address</FormLabel>
              <Input type="email" 
                value={email}
                onChange={(e) => setEmail(e.target.value)} />
            </FormControl>

            <FormControl isRequired id="password">
              <FormLabel>Password</FormLabel>
              <PasswordField 
                id="password"
                value={password}
                showStrengthBar={false}
                onChange={(e) => setPassword(e.target.value)}/>
            </FormControl>

            <Stack spacing={10}>
              <Button
                type="submit"
                width="full" 
                mt={4}
                _hover={{ bg: 'teal.500', color: 'white' }} 
                colorScheme='teal'
                isLoading={isLoading}>
                Login
              </Button>
              {/* <Text>
                Have Admin registration access code?{' '}
                <Link color='blue.400' href='/admin/register'>
                    Register
                </Link>
              </Text>  */}
            </Stack>
          </Stack>
          </form>
        {/* </Box> */}
      </Stack>
    </Flex>
  )
}

export default AdminLogin;